
export const Loader = (data) => {
    return (dispatch) => {
        dispatch({ type: "IS_LOADING", data: data });
    };
};

export const Login = (data) => {
    return (dispatch) => {
        dispatch({ type: "IS_LOGIN", data: data });
    };
};